import { useState } from 'react'
import ReportFixedTable from 'features/report/table/ReportFixedTable'
import ReportScrollableTable from 'features/report/table/ReportScrollableTable'
import classNames from 'classnames'
import MultiTable from 'components/table/MultiTable'
import {
  ReportColumnAdGroupName,
  ReportColumnBizChannelName,
  ReportColumnCampaignName,
  ReportColumnCampaignType,
  ReportColumnCreativeName,
  ReportColumnEndDate,
  ReportColumnStartDate,
} from 'features/report/common/ReportColumns'

const ReportCreativeTable = () => {
  const [isScrolled, setIsScrolled] = useState(false)

  return (
    <div className={classNames('table_wrap', { scroll_ing: isScrolled })}>
      <MultiTable.Container>
        <ReportFixedTable />
        <ReportScrollableTable
          caption="맞춤보고서 소재 테이블"
          onIsScrolledChange={setIsScrolled}
          baseColumns={[
            ReportColumnCampaignType,
            ReportColumnCampaignName,
            ReportColumnAdGroupName,
            ReportColumnBizChannelName,
            ReportColumnCreativeName,
            ReportColumnStartDate,
            ReportColumnEndDate,
          ]}
        />
      </MultiTable.Container>
    </div>
  )
}

export default ReportCreativeTable
